import {cn} from '@sollapay/ui';
import {Button, Icon, Popover, PopoverTrigger, Typography} from '@sollapay/ui/components';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {config} from '@/app/app.config';

import {ReportBugModal} from './ReportBugModal';

import type {FC} from 'react';

export interface ReportBugButtonProps {
  showAttentionDot?: boolean;
  className?: string;
}

export const ReportBugButton: FC<ReportBugButtonProps> = ({
  showAttentionDot = false,
  className
}) => {
  const {t} = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);

  if (!config.sentryDsn) return null;

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger
        render={
          <Button
            variant="secondary"
            className={cn(
              'z-60 h-9 gap-3 rounded-md px-3 py-0 shadow-xs',
              'hover:bg-background-surface aria-expanded:bg-background-surface',
              className
            )}
          >
            <span className="relative inline-flex shrink-0">
              <Icon
                name="bug"
                width={17}
                height={17}
                strokeWidth={1.8}
                className="text-fg-quaternary transition-colors group-hover/button:text-fg-secondary"
              />
              {showAttentionDot && (
                <span
                  data-slot="attention-dot"
                  className="absolute -top-0.5 -start-0.5 size-1.75 rounded-full bg-destructive ring-2 ring-background-surface"
                />
              )}
            </span>
            <Typography
              as="span"
              size="sm"
              weight="medium"
              className="text-fg-secondary transition-colors group-hover/button:text-fg"
            >
              {t('reportBug.buttonLabel')}
            </Typography>
          </Button>
        }
      />
      <ReportBugModal onOpenChange={setIsOpen} />
    </Popover>
  );
};
